import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface DateRangeFilterProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  onClear: () => void;
}

export function DateRangeFilter({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onClear,
}: DateRangeFilterProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center p-4 border border-border rounded-lg bg-card">
      <div className="flex flex-col sm:flex-row gap-4 flex-1">
        <div className="flex flex-col gap-2 min-w-[140px]">
          <Label htmlFor="start-date" className="text-sm font-medium">
            Start Date
          </Label>
          <Input
            id="start-date"
            type="date"
            value={startDate}
            onChange={(e) => onStartDateChange(e.target.value)}
          />
        </div>
        <div className="flex flex-col gap-2 min-w-[140px]">
          <Label htmlFor="end-date" className="text-sm font-medium">
            End Date
          </Label>
          <Input
            id="end-date"
            type="date"
            value={endDate}
            onChange={(e) => onEndDateChange(e.target.value)}
            min={startDate}
          />
        </div>
      </div>
      {(startDate || endDate) && (
        <Button variant="outline" size="sm" onClick={onClear}>
          Clear Dates
        </Button>
      )}
    </div>
  );
}
